module.exports = __webpack_public_path__ + "static/img/xc1.452f3dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xc1.jpg
// module id = 7N4F
// module chunks = 0